module.exports = __webpack_public_path__ + "static/media/sqlserver.90396714.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sqlserver.png
// module id = 195
// module chunks = 0